import React, { useState } from "react";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import AssignmentIcon from "@material-ui/icons/Assignment";
import "../App.css";
import { makeStyles, Tooltip } from "@material-ui/core";
import Contact from "./Contact";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import { isMobile } from "react-device-detect";

const useStyles = makeStyles((theme) => ({
  iconPlay: {
    color: "greenyellow",
    cursor: "pointer",
    fontSize: 25,
    marginRight: 5,
  },
  iconAssignment: {
    color: "antiquewhite",
    cursor: "pointer",
    fontSize: 20,
    marginRight: 5,
  },
}));

export default function Tabs({
  files,
  active,
  add,
  choose,
  close,
  run,
  handleSettings,
  setting,
  copyClipboard,
  format,
}) {
  const classes = useStyles();
  return (
    <div className="tabs">
      <div style={{ flexDirection: "row", display: "flex" }}>
        {files.map((file, index) => (
          <Tab
            key={file.id}
            isActive={active === index}
            close={close}
            index={index}
          >
            <button onClick={() => choose(index)}>{file.title}</button>
          </Tab>
        ))}

        <div />

        <Tab>
          <button onClick={add}>+</button>
        </Tab>
      </div>
      <div
        className="actions"
        style={{ justifyContent: isMobile ? "flex-end" : "space-between" }}
      >
        <Tooltip title="Run" arrow>
          <PlayArrowIcon className={classes.iconPlay} onClick={run} />
        </Tooltip>

        {!isMobile && (
          <>
            <Tooltip title="Re-format" arrow>
              <AssignmentTurnedInIcon
                className={classes.iconAssignment}
                onClick={format}
              />
            </Tooltip>

            <Tooltip title="Copy" arrow>
              <AssignmentIcon
                className={classes.iconAssignment}
                onClick={copyClipboard}
              />
            </Tooltip>

            <Contact handleSettings={handleSettings} setting={setting} />
          </>
        )}
      </div>
    </div>
  );
}

function Tab({ index, children, close, isActive }) {
  const [highlightStyle, setHighlightStyle] = useState({
    left: 0,
  });

  function moveHighlight(e) {
    setHighlightStyle({
      opacity: 0.4,
      left: e.nativeEvent.layerX - 250,
    });
  }

  function hideHighlight(e) {
    setHighlightStyle({ opacity: 0, left: e.nativeEvent.layerX - 250 });
  }

  return (
    <div
      className={`tab ${isActive ? "is-active" : ""}`}
      onMouseOut={hideHighlight}
      onMouseMove={moveHighlight}
    >
      <div className="highlight" style={highlightStyle} />
      {children}
      {isActive && index && close ? (
        <button className="close-tab" onClick={() => close(index)}>
          x
        </button>
      ) : (
        <></>
      )}
    </div>
  );
}
